var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.151,
    height: 15.509,
    viewBox: "0 0 22.151 15.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "youtube",
    d: "M21.695-3.655a2.775,2.775,0,0,0-1.952-1.953c-1.733-.474-8.667-.474-8.667-.474s-6.934,0-8.667.456A2.831,2.831,0,0,0,.456-3.655,29.241,29.241,0,0,0,0,1.673,29.134,29.134,0,0,0,.456,7,2.776,2.776,0,0,0,2.409,8.953c1.752.474,8.667.474,8.667.474s6.934,0,8.667-.456A2.775,2.775,0,0,0,21.7,7.019a29.251,29.251,0,0,0,.456-5.328A27.757,27.757,0,0,0,21.695-3.655ZM8.868,4.994V-1.648l5.766,3.321Zm0,0",
    transform: "translate(0 6.082)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.654c17df6097c5a1886bd984209677d1.svg";
export { ForwardRef as ReactComponent };